function getSentryConfig() {
  const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content
  const environment = document.querySelector('meta[name="sentry-environment"]')?.content
  const release = document.querySelector('meta[name="sentry-release"]')?.content

  if (!dsn) return null

  return { dsn, environment, release }
}

function getSentryUser() {
  const customerId = document.querySelector('meta[name="sentry-customer-id"]')?.content
  const adminId = document.querySelector('meta[name="sentry-admin-id"]')?.content

  if (!customerId && !adminId) return null

  const user = {}
  if (customerId) user.customer_id = customerId
  if (adminId) user.admin_id = adminId
  if (adminId) {
    user.id = `admin:${adminId}`
  } else if (customerId) {
    user.id = `customer:${customerId}`
  }

  return user
}

export { getSentryConfig, getSentryUser }
